import { defineModel, resolvesTo } from 'customer-flows/utils/quote/models'

export default defineModel({
  customer: resolvesTo('customer')
})
